exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".player-modal-wrapper .player-wrapper iframe {\n\twidth: 100%;\n\theight: auto;\n}\n\n.player-modal-wrapper .close-btn {\n\tposition: absolute;\n    top: -13px;\n    right: -13px;\n    z-index: 100;\n}\n\n.player-modal-wrapper .close-btn i {\n\tfont-size: 20px;\n\tcolor: #ccc;\n}\n\n.player-modal-wrapper .player-wrapper {\n}\n\n.player-modal-wrapper .player-wrapper video {\n\twidth: 100%;\n}\n\nvg-track-selector select.trackSelector {\n\tpadding: 0 !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/player-modal/player-modal.component.css
// module id = ../../../../../src/app/modals/player-modal/player-modal.component.css
// module chunks = main